import { usePrevious } from '@lbcamden/lib-react';
import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router';

import { useAppStore } from '~/client/store/app/appStore';

export const useRecordPreviousPathname = () => {
  const { pathname } = useLocation();
  const prevPathname = usePrevious(pathname);

  const navType = useNavigationType();

  const setPreviousPathname = useAppStore((state) => state.setPreviousPathname);

  useEffect(() => {
    switch (navType) {
      case 'REPLACE':
        return;
      case 'PUSH':
        return void (prevPathname && setPreviousPathname(prevPathname));
      case 'POP':
      default:
        setPreviousPathname(undefined);
    }
  }, [pathname]);
};
